import './component.scss'
import { Controller } from "stimulus";

window.Stimulus.register(
  'nurikae-area-tabs',
  class extends Controller {
    // NOTE: タブでの検索URLをaタグで実装するとクローラーに辿られてしまう
    // 本来は辿られたくないので、JS遷移にすることでこの問題に対応する (検証段階)
    navigate(event) {
      const url = event.currentTarget.dataset.nurikaeAreaTabsUrlValue;
      if (url) {
        window.location.href = url;
      }
    }
  }
)
